var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import client from 'api/environment';
import MOVE_PRODUCT_CATEGORY from 'api/mutations/MOVE_PRODUCT_CATEGORY';
import UPDATE_PRODUCT_CATEGORY from 'api/mutations/UPDATE_PRODUCT_CATEGORY';
import GET_PRODUCT_CATEGORIES from 'api/queries/GET_PRODUCT_CATEGORIES';
const createInitialState = () => ({
    items: [],
    pageInfo: {
        hasNextPage: false,
        endCursor: null,
    },
    status: {
        fetch: 'idle',
        update: 'idle',
        move: 'idle',
    },
    errors: {
        fetch: null,
        update: null,
        move: null,
    },
    refetchFlags: {
        fetch: false,
        update: false,
        move: false,
    },
});
export const fetchProductCategories = createAsyncThunk('productCategories/fetch', (_1, _a) => __awaiter(void 0, [_1, _a], void 0, function* (_, { rejectWithValue }) {
    try {
        const response = yield client.query({
            query: GET_PRODUCT_CATEGORIES,
            fetchPolicy: 'network-only',
        });
        return response.data.autocomplete.productCategories;
    }
    catch (error) {
        const apolloError = error;
        return rejectWithValue(apolloError.message);
    }
}));
export const updateProductCategory = createAsyncThunk('productCategories/update', (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({ id, typeLabelPL, typeLabelEN, filtersAvailable, }, { rejectWithValue }) {
    try {
        const response = yield client.mutate({
            mutation: UPDATE_PRODUCT_CATEGORY,
            variables: { productCategoryId: id, typeLabelPL, typeLabelEN, filtersAvailable },
        });
        return response.data.updateProductCategory.productCategory;
    }
    catch (error) {
        const apolloError = error;
        return rejectWithValue(apolloError.message);
    }
}));
export const moveProductCategory = createAsyncThunk('productCategories/move', (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({ productCategoryId, direction, }, { rejectWithValue }) {
    try {
        const response = yield client.mutate({
            mutation: MOVE_PRODUCT_CATEGORY,
            variables: { productCategoryId, direction },
        });
        return response.data.moveProductCategory.productCategories;
    }
    catch (error) {
        const apolloError = error;
        return rejectWithValue(apolloError.message);
    }
}));
const productCategoriesSlice = createSlice({
    name: 'productCategories',
    initialState: createInitialState(),
    reducers: {
        resetProductCategories: () => createInitialState(),
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchProductCategories.pending, (state) => {
            state.status.fetch = 'loading';
            state.refetchFlags.fetch = false;
        })
            .addCase(fetchProductCategories.fulfilled, (state, action) => {
            state.items = action.payload.edges.map((edge) => edge.node);
            state.pageInfo = action.payload.pageInfo;
            state.status.fetch = 'succeeded';
        })
            .addCase(fetchProductCategories.rejected, (state, action) => {
            state.status.fetch = 'failed';
            state.errors.fetch = action.payload || action.error.message || null;
        })
            .addCase(updateProductCategory.pending, (state) => {
            state.status.update = 'loading';
        })
            .addCase(updateProductCategory.fulfilled, (state, action) => {
            const itemIndex = state.items.findIndex((item) => item.id === action.payload.id);
            if (itemIndex !== -1) {
                state.items[itemIndex] = action.payload;
            }
            state.status.update = 'succeeded';
        })
            .addCase(updateProductCategory.rejected, (state, action) => {
            state.status.update = 'failed';
            state.errors.update = action.payload || action.error.message || null;
        })
            .addCase(moveProductCategory.pending, (state) => {
            state.status.move = 'loading';
        })
            .addCase(moveProductCategory.fulfilled, (state, action) => {
            state.items = action.payload;
            state.status.move = 'succeeded';
        })
            .addCase(moveProductCategory.rejected, (state, action) => {
            state.status.move = 'failed';
            state.errors.move = action.payload || action.error.message || null;
        });
    },
});
export const { resetProductCategories } = productCategoriesSlice.actions;
export const selectProductCategories = (state) => state.parameters.productCategories.items;
export const selectProductCategoryById = (state, productCategoryId) => state.parameters.productCategories.items.find((productCategory) => productCategory.id === productCategoryId);
export const selectProductCategoriesPageInfo = (state) => state.parameters.productCategories.pageInfo;
export const selectProductCategoriesStatus = (state) => state.parameters.productCategories.status;
export const selectProductCategoriesErrors = (state) => state.parameters.productCategories.errors;
export const selectProductCategoriesRefetchFlags = (state) => state.parameters.productCategories.refetchFlags;
export default productCategoriesSlice.reducer;
